import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as ProfileAPI from '../../../API/ProfileAPI'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    userProfile: {},
    profileLoading: false,
    userError: ''
}
const ProfileStore = (set, get) => ({
    ...initialState,
    getUserProfile: async () => {
        set({ ...initialState, profileLoading: true })
        try {
            const response = await ProfileAPI.getUserProfile()
            if (response.data) {
                set({ ...initialState, profileLoading: false, userProfile: response.data })
            } else {
                set({ ...initialState, profileLoading: false, userProfile: { name: 'John Rampo', profileImage: null } })
            }
        } catch (err) {
            console.warn(err)
        }
    }

})

export const useProfileStore = create(devtools(immer(ProfileStore)))
